import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetChargesPoliciesRequestSchema,
  TGetChargesPoliciesResponseSchema,
} from "./getChargesPolicies.schema";

export const getChargesPolicies = (axios: IAxiosInstance) => {
  return async (params: TGetChargesPoliciesRequestSchema) => {
    const { companyID } = params;
    const response = await axios.noRetry.get<
      IApiResponse<TGetChargesPoliciesResponseSchema>
    >(`/charges-and-fees/${companyID}/policies`, {
      params,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
